import type { ReactNode } from 'react';

import { CUSTOMER_RANGE_TITLE } from '../../constants';
import {
    DealPulseRowStyle,
    DealPulseLabelStyle,
    DealPulseLineStyle,
    DealPulseRangeStyle,
    DealPulseValueStyle
} from './DealPulseRow.style';

type DealPulseRowProps = {
    label: string;
    value: string | number;
    range: ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
};

const DealPulseRow = ({ label, value, range, header, footer }: DealPulseRowProps) => {
    return (
        <DealPulseRowStyle>
            {header}
            <DealPulseLineStyle>
                <DealPulseLabelStyle>{label}: </DealPulseLabelStyle>
                <DealPulseValueStyle> {value.toLocaleString()}</DealPulseValueStyle>
            </DealPulseLineStyle>
            <DealPulseRangeStyle>
                {CUSTOMER_RANGE_TITLE}: {range}
            </DealPulseRangeStyle>
            {footer}
        </DealPulseRowStyle>
    );
};

export default DealPulseRow;
